import { TH } from '../lib/constants.js';
import { seededRand } from '../lib/helpers.js';

export function MissingDayArt({day,year,theme}){
  const th=TH[theme]||TH.neon;
  const rand=seededRand(year*1000+day);
  const c1=th.ac,c2=th.ac2||th.pill;
  const blobs=Array.from({length:4}).map(()=>({
    cx:18+rand()*64,cy:18+rand()*64,rx:22+rand()*26,ry:22+rand()*26,rot:rand()*360,
  }));
  const gid=`mda-${year}-${day}`;
  return(
    <svg viewBox="0 0 100 100" style={{position:"absolute",inset:0,width:"100%",height:"100%"}} preserveAspectRatio="xMidYMid slice">
      <defs>
        <radialGradient id={gid} cx="50%" cy="50%" r="70%">
          <stop offset="0%" stopColor={c1} stopOpacity=".55"/>
          <stop offset="100%" stopColor={c2} stopOpacity=".18"/>
        </radialGradient>
      </defs>
      <rect width="100" height="100" fill={th.bg}/>
      {blobs.map((b,i)=>(
        <ellipse key={i} cx={b.cx} cy={b.cy} rx={b.rx} ry={b.ry} transform={`rotate(${b.rot} ${b.cx} ${b.cy})`} fill={`url(#${gid})`} opacity={0.75-i*0.14}/>
      ))}
    </svg>
  );
}
